// Central Day.js configuration. Import the default export from this module
// (not directly from 'dayjs') anywhere plugin-backed behaviour is required, so
// the plugins below are guaranteed to be registered before use.
//
// Plugins map 1:1 to the Moment features this codebase relied on:
//   - customParseFormat: strict/format-string parsing, e.g. dayjs(v, 'MM/DD/YYYY', true)
//   - localeData:        month/weekday name lookups used by the Material date adapter
//   - localizedFormat:   the 'LL' token used for datepicker a11y labels
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(customParseFormat);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);

export default dayjs;
